<template>
  <!-- 选择商品弹窗 -->
  <el-dialog
    title="选择商品"
    :visible.sync="selectDialog"
    width="1080px"
    :before-close="handleDialogClose"
    class="select-goods my_select_goods"
    append-to-body
  >
    <template slot="title">
      <span>选择商品</span>
    </template>
    <div class="evaluate-dialog-wrapper">
      <!-- 筛选部分 -->
      <div class="screen-box">
        <div class="line">
          <div class="item" style="margin-right: 100px;">
            <span class="item-name">指定品牌：</span>
            <!-- 指定品牌弹出框 -->
            <el-popover width="280" v-model="brandVisible">
              <div class="brand-checked-wrapper">
                <div class="wrapper-header">
                  <span style="float: left">指定品牌</span>

                  <div style="clear: both"></div>
                </div>
                <div style="margin: 15px 0"></div>
                <el-checkbox-group v-model="checkedBrands" @change="handleCheckedBrandsChange">
                  <div v-infinite-scroll="load" style="overflow:auto;height:200px;" infinite-scroll-disabled="disabled1">
                    <el-checkbox :label="item" :key="index" v-for="(item, index) in brandOptions" style="display: block; margin-bottom: 8px;">{{
                      item.pidName
                    }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
              <div style="justify-content: center;display:flex;align-items:center;">
                <span style="margin-right:5px">共{{ specifyformcrowdTotal }}条</span>
                <el-button size="mini" @click="brandVisible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="brandConfirm()">确定</el-button>
              </div>
              <el-button slot="reference" size="small" class="brandButton">{{
                checkedBrands.length > 0 ? "已选择" + checkedBrands.length + "个" : "默认全部"
              }}</el-button>
            </el-popover>
          </div>
          <div class="item">
            <el-select v-model="classifyValue" placeholder="淘宝类目" class="classify-select" size="small" @change="classifyChange">
              <el-option v-for="item in classifyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-popover placement="bottom" width="300" v-model="visible" popper-class="poper">
              <div class="popper-wrapper">
                <el-tree
                  ref="taobaoTree"
                  node-key="id"
                  v-if="classifyIndex === 1"
                  :data="taobaoCats"
                  :props="props"
                  show-checkbox
                  @check-change="handleCheckChange"
                ></el-tree>
                <el-tree
                  ref="sellerTree"
                  node-key="id"
                  v-else-if="classifyIndex === 2"
                  :data="sellerCats"
                  :props="props"
                  show-checkbox
                  @check-change="handleCheckChange"
                ></el-tree>
              </div>
              <div style="text-align: right; margin-top: 20px">
                <el-checkbox v-model="checkedAll" @change="handleCheckAllChangeTaoBao" style="float: left; line-height: 26px">全选</el-checkbox>
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="getCheckedKeys()">确定</el-button>
              </div>
              <el-button slot="reference" size="small" class="goods-button">
                {{ classifyIdArray.length > 0 ? "已选择" + classifyIdArray.length + "项" : "默认全部" }}
              </el-button>
            </el-popover>
          </div>
        </div>
        <div class="line">
          <div class="item" style="margin-right: 103px">
            <span class="item-name">商品名称：</span>
            <el-input class="short-input" style="width: 300px" placeholder="请输入商品名称" size="small" v-model="itemTitle"></el-input>
          </div>
          <div class="item" style="margin-right: 15px">
            <span class="item-name">商品ID：</span>
            <el-input
              class="short-input"
              style="width: 300px"
              placeholder="请输入商品ID,多个商品ID间用逗号分隔"
              size="small"
              @input="validNum"
              @change="changeNum"
              v-model="numIid"
            ></el-input>
          </div>
        </div>
        <div class="line">
          <div class="item" style="margin-right: 0;width:100%;display:flex;justify-content:space-between;align-items:flex-end;">
            <el-button class="button searchBtn" size="small" type="primary" @click="searchList()">查询</el-button>
            <div>
              <!-- <span style="margin-right:10px;cursor: pointer;" @click='handleBabyGroup'>宝贝分组</span> -->
              <el-button type="text" @click="handleBabyGroup">宝贝分组</el-button>
              <el-button type="text" icon="el-icon-plus" style="width:130px" @click="addGoodVisible = true">添加已下架商品</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格部分 -->
      <div class="table-box">
        <div class="table-left">
          <el-table
            :data="leftData"
            max-height="440"
            :header-cell-style="{ background: 'rgba(244,245,249,1)' }"
            style="width: 530px; border: 1px solid #e1e1e6"
            :row-class-name="tableRowClassName"
          >
            <el-table-column label="店中宝贝" align="center" width="450">
              <template slot-scope="scope">
                <img :src="scope.row.picUrl ? scope.row.picUrl : require('@/assets/images/无商品.png')" class="goods-img" alt />
                <div class="goods-content">
                  <span class="goods-title" @click="toGoodDetail(scope.row.itemLink)">{{ scope.row.itemTitle }}</span>
                  <div class="goods-detail">
                    <span class="goods-id">商品ID:{{ scope.row.numIid }}</span>
                    <span class="goods-price"
                      >￥<span class="price">{{ scope.row.price }}</span>
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="68">
              <template slot="header" slot-scope="scope">
                <el-button size="small" type="text" @click="handleAllSelect()" style="text-align:left;font-size: 14px">全选</el-button>
              </template>
              <template slot-scope="scope">
                <i
                  class="el-icon-circle-plus-outline add-button addDisabled"
                  :style="{ color: changeColor }"
                  v-if="scope.row.state === true"
                ></i>
                <i
                  class="el-icon-circle-plus-outline add-button"
                  :style="{ color: changeColor }"
                  v-else
                  @click="handleSelect(scope.row, scope.$index)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <pagination @transferName="leftCurrentChange" :total="leftPaginationInfo.total" style="width: 540px"></pagination>
        </div>
        <div class="table-right">
          <el-table
            :data="rightDataNow"
            max-height="440"
            :header-cell-style="{ background: 'rgba(244,245,249,1)' }"
            style="width: 490px; border: 1px solid #e1e1e6"
          >
            <el-table-column align="center" width="420">
              <template slot="header" slot-scope="scope">
                <span>已选择宝贝</span>
                <!-- <span class="is-select">({{ rightPaginationInfo.totalCount }})</span> -->
                <span class="is-select">({{ rightData.length }})</span>
                <el-button size="small" type="text" @click="handleSaveFZ" style="font-size: 14px;position: absolute;right: 0px;top: 3px;"
                  >保存为分组</el-button
                >
              </template>
              <template slot-scope="scope">
                <img :src="scope.row.picUrl ? scope.row.picUrl : require('@/assets/images/无商品.png')" class="goods-img" alt />
                <div class="goods-content">
                  <span class="goods-title" @click="toGoodDetail(scope.row.itemLink)">{{ scope.row.itemTitle }}</span>
                  <div class="goods-detail">
                    <span class="goods-id">商品ID:{{ scope.row.numIid }}</span>
                    <span class="goods-price">
                      ￥<span class="price">{{ scope.row.price }}</span>
                    </span>
                  </div>
                  <el-popover v-if="skuIsShow" placement="bottom-start" width="250" trigger="click">
                    <div class="specsList">
                      <span
                        :class="{ active: info.skuIsActive }"
                        v-for="info in scope.row.skuId"
                        :key="info.skuId"
                        @click="selectSkuInfo(info, scope.row)"
                      >
                        {{ info.propertiesName }}
                      </span>
                    </div>

                    <div slot="reference" class="selectSku" v-show="scope.row.skuId && scope.row.skuId.length > 0">
                      选择SKU<span v-if="scope.row.skuIdlen > 0">({{ scope.row.skuIdlen }})</span>
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="68">
              <template slot="header" slot-scope="scope">
                <el-button size="small" type="text" @click="handleClear()" style="font-size: 14px;text-align:left">清空</el-button>
              </template>
              <template slot-scope="scope">
                <i class="el-icon-circle-close delete-button" :style="{ color: '#f82e2e' }" @click="handleDelete(scope.row, scope.$index)"></i>
              </template>
            </el-table-column>
          </el-table>
          <pagination @transferName="rightCurrentChange" :total="rightPaginationInfo.totalCount" style="width: 490px"></pagination>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer select_good_footer">
      <el-button @click="handleDialogClose()" class="button" size="small">取消</el-button>
      <el-button type="primary" @click="handleDialogConfirm()" class="button" size="small">确定</el-button>
    </div>

    <el-dialog
      title="添加已下架商品"
      :visible.sync="addGoodVisible"
      width="472px"
      :before-close="handleAddGoodClose"
      class="select-goods my_select_goods"
      append-to-body
    >
      <div style="margin-bottom:25px;margin-left:27px;">
        筛选购买商品时，以商品ID作为唯一标识，请确保商品ID正确
      </div>
      <div class="addGoodItem">
        <div class="item-left"><span style="color:#ee3b3b">*</span>商品名称：</div>
        <div class="item-right">
          <el-input v-model="formAddGood.itemTitle"></el-input>
        </div>
      </div>
      <div class="addGoodItem">
        <div class="item-left"><span style="color:#ee3b3b">*</span>商品ID：</div>
        <div class="item-right">
          <el-input v-model="formAddGood.numIid"></el-input>
        </div>
      </div>
      <div class="addGoodItem">
        <div class="item-left">店铺类目：</div>
        <div class="item-right">
          <el-cascader v-model="formAddGood.sellerCats" :options="sellerCats" :props="props2" style="width:100%"></el-cascader>
          <!-- <el-select
              v-model="formAddGood.sellerCats"
              clearable
              placeholder="请选择"
              @clear="handleClear"
              ref="selectUpResId"
            >
              <el-option hidden key="upResId" :value="formAddGood.upResId" :label="upResName">
              </el-option>
              <el-tree
                :data="sellerCats"
                :props="props"
                :expand-on-click-node="false"
                :check-on-click-node="true"
                @node-click="handleNodeClick"
              >
              </el-tree>
            </el-select> -->
        </div>
      </div>
      <div class="addGoodItem">
        <div class="item-left">淘宝类目：</div>
        <div class="item-right">
          <el-cascader v-model="formAddGood.cid" :options="taobaoCats" :props="props2" style="width:100%"></el-cascader>
        </div>
      </div>
      <div class="addGoodItem" style="justify-content: center;margin-bottom:24px">
        <el-button @click="handleAddGoodClose" style="width:96px;">取消</el-button>
        <el-button @click="addGoodSold" :loading="addGoodLoading" type="primary" size="small" style="width:96px;">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="保存为分组"
      :visible.sync="saveGroupVisible"
      width="500px"
      :before-close="handleSaveGroupClose"
      class="select-goods my_select_goods"
      append-to-body
    >
      <div class="addGoodItem" style="margin-left:27px">当前已选择宝贝{{ rightPaginationInfo.totalCount }}个</div>
      <div class="addGoodItem">
        <el-radio-group v-model="formsaveGroup.radio" style="margin-left:27px">
          <el-radio :label="1">新建分组</el-radio>
          <el-radio :label="2">已有分组</el-radio>
        </el-radio-group>
      </div>
      <div class="addGoodItem" v-if="formsaveGroup.radio == 1">
        <div class="item-left">分组名称：</div>
        <div class="item-right">
          <el-input v-model="formsaveGroup.name"></el-input>
        </div>
      </div>
      <div class="addGoodItem" v-if="formsaveGroup.radio == 2">
        <div class="item-left">选择分组：</div>
        <div class="item-right">
          <el-select v-model="formsaveGroup.selectName" style="width:100%">
            <el-option v-for="item in groupingSelect" :key="item.taobaoItemGroupId" :label="item.name" :value="item.taobaoItemGroupId"></el-option>
          </el-select>
        </div>
      </div>
      <div class="addGoodItem" style="justify-content: center;">
        <el-button @click="handleSaveGroupClose" style="width:96px;">取消</el-button>
        <el-button @click="sumbitGroup" :loading="saveGroupLoading" type="primary" size="small" style="width:96px;">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="宝贝分组"
      :visible.sync="groupingVisible"
      width="600px"
      :before-close="handleGroupingClose"
      class="select-goods my_select_goods"
      append-to-body
      v-if="groupingVisible"
    >
      <el-table
        :data="groupingData"
        v-loading="groupingTableLoading"
        tooltip-effect="dark"
        :header-cell-style="{
          background: 'rgba(244,245,249,1)',
          fontWeight: 'bold',
        }"
        style="width: 100%; border: 1px solid #eee;"
      >
        <el-table-column property="name" label="分组名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="num" label="所选宝贝数" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <i
              @click="selectGroupAdd(scope.row.taobaoItemGroupId)"
              style="font-size: 18px;cursor: pointer;margin-right:10px;"
              :style="{ color: changeColor }"
              class="el-icon-circle-plus"
            ></i>
            <el-popconfirm title="确定删除该分组吗？" @confirm="deleteGrouping(scope.row.taobaoItemGroupId)">
              <i slot="reference" style="font-size: 18px;cursor: pointer;" class="el-icon-delete"></i>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="position:relative;top:10px;margin-bottom:40px;text-align: right;"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="groupingTotal"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :current-page="formGrouping.pageNum"
        @current-change="handleCurrentGroupingChange"
        @size-change="handleSizeGroupingChange"
        :page-size="formGrouping.pageSize"
      >
      </el-pagination>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  getBrandList,
  getTaobaocats,
  getSellercats,
  getTaobaoItemList,
  getTaobaoItemSkuList,
  addUnshelveItem,
  taobaoItemGroupList,
  getTaobaoItemFromGroup,
  deleteTaobaoItemGroup,
  addTaobaoItemGroup,
} from "@/api/public1";
import Pagination from "./pagination1.vue";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "select-goods",
  components: { Pagination },
  props: {
    postForm: {
      type: Array,
    },
    shopType: {
      type: Number,
      default: 0,
    },
    skuIsShow: {
      type: Boolean,
      default: false,
    },
    maxNum: {
      type: Number,
      default: 1000000000,
    },
  },
  watch: {
    rightData(nval, oval) {
      console.log('nval',nval)
      this.rightPaginationInfo.totalCount = this.rightData.length;
      this.rightDataNow = nval.slice(
        (this.rightPaginationInfo.tableCurrentPage - 1) * this.rightPaginationInfo.pageSize,
        this.rightPaginationInfo.tableCurrentPage * this.rightPaginationInfo.pageSize
      );

      this.rightDataId = [];
      //
      this.rightData.forEach((e1) => {
        this.rightDataId.push(e1.numIid);
        this.leftData.forEach((e2) => {
          if (e1.numIid == e2.numIid) {
            e2.state = true;
          }
        });
      });
      console.log('rightDataNow',this.rightDataNow);
    },
  },
  data() {
    return {
      Warenauswahl: 1,
      changeColor: "#2062E7",
      skuArrTd: [], //全选
      addGoodVisible: false,
      saveGroupVisible: false,
      groupingVisible: false,
      upResName: "",
      formAddGood: {
        sellerCats: "",
        cid: "",
      },
      formsaveGroup: {
        radio: 1,
        selectName: "",
      },
      formGrouping: {
        pageNum: 1,
        pageSize: 10,
      },
      addGoodLoading: false,
      saveGroupLoading: false,
      groupingTotal: 0,
      groupingData: [],
      groupingTableLoading: false,
      // changeColor: "#2062E7",
      selectDialog: true,
      brandVisible: false, //指定品牌弹出框
      brandOptions: [], //品牌列表
      checkedBrands: [], //选中品牌
      checkedBrandsString: "", //选中的品牌ID
      isIndeterminate: true,
      checkAll: false,
      checkedAll: false,
      specifyform: {
        pageNum: 2,
        size: 10,
      },
      specifyformcrowdTotal: 100,
      specifyData: [],
      rightDataNow: [],
      /*
       * 类目选择相关
       * */
      classifyOptions: [
        {
          value: 1,
          label: "淘宝类目",
        },
        {
          value: 2,
          label: "店铺类目",
        },
      ],
      classifyValue: 1,
      classifyIndex: 1,
      classifyIdArray: [],
      classifyIdString: "",
      visible: false, //类目渲染
      /*
       * 商品状态相关
       * */
      goodState: [
        {
          value: 0,
          label: "全部商品",
        },
        {
          value: 1,
          label: "在售",
        },
        {
          value: 2,
          label: "待售",
        },
      ],
      goodValue: 0,
      /*
       * 树形选择相关
       * */
      cats: [], //当前展示的类目
      taobaoCats: [], //淘宝类目
      sellerCats: [], //店铺类目
      props: {
        label: "speName001",
        children: "child",
      },
      props2: {
        label: "speName001",
        children: "child",
        value: "id",
        emitPath: false,
      },
      itemTitle: "", //商品名称
      numIid: "", //商品id
      startPrice: "", //开始价格
      endPrice: "", //结束价格
      /*
       * 选择商品左侧表格
       * */
      leftData: [],
      newData: [],
      alreadyList: [],
      /*
       * 左侧商品分页数据
       * */
      leftPaginationInfo: {
        current: 1, //当前页数
        pageSize: 10, //当前页面数据大小
        total: 0, //数据总数
      },
      /*
       * 选择商品右侧表格
       * */
      rightData: [],
      rightDataId: [],
      /*
       * 右侧商品分页数据
       * */
      rightPaginationInfo: {
        tableCurrentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      groupingSelect: [],
    };
  },
  computed: {
    ...mapState({
      //   Warenauswahl: "Warenauswahl",
      //   excludeList: "excludeList",
      //   assignList: "assignList",
      //   changeColor: "globalBG",
    }),

    noMore() {
      return this.specifyData.length >= this.specifyformcrowdTotal;
    },
    disabled1() {
      return this.noMore;
    },
  },
  beforeCreate() {},
  beforeMount() {},
  created() {
    let self = this;
    let alreadyList = [];
    if (this.postForm && this.postForm.length > 0) {
      alreadyList = JSON.parse(JSON.stringify(self.postForm));
      //  this.postForm.map(item => {
      //   return {
      //     ...item
      //   };
      // });
    }
    for (let i = 0; i < alreadyList.length; i++) {
      alreadyList[i].state = true;
    }
    //this.leftData=JSON.parse(JSON.stringify(alreadyList));
    this.rightData = JSON.parse(JSON.stringify(alreadyList));
    console.log('rightData',this.rightData)
    // for (const item of alreadyList) {
    //   this.leftData.push(item);
    //   this.rightData.push(item);
    // }
    this.rightPaginationInfo.totalCount = this.rightData.length;
  },
  mounted() {
    console.log(this.skuIsShow);
    // console.log("传过来的数据",this.shopType);
    let self = this;
    // console.log(this.modelName);
    /*
     * 获取品牌列表
     * */
    getBrandList({}).then((res) => {
      // console.log("%c 品牌列表", "color: green", res.data);
      // if(res.code === 200){
      console.log(res);
      this.specifyData = res.data.dataList;
      this.brandOptions = this.specifyData;
      this.specifyformcrowdTotal = parseInt(res.data.pageInfo.total);
      // };
      // self.brandOptions = res.data;
    });
    /*
     * 获取淘宝类目
     * */
    getTaobaocats({}).then((res) => {
      // console.log("%c 淘宝类目", "color: green", res.data);
      self.cats = res.data;
      self.taobaoCats = res.data;
      console.log(self.taobaoCats);
      this.recursionGoods(self.taobaoCats);
    });
    /*
     * 获取店铺类目
     * */
    getSellercats({}).then((res) => {
      // console.log("%c 店铺类目", "color: green", res.data);
      self.sellerCats = res.data;
      this.recursionGoods(self.sellerCats);
      console.log(self.sellerCats);
    });
    /*
     * 获取商品列表
     * */
    self.getTaobaoItemList();
  },
  methods: {
    // handleNodeClick(data) {
    //   console.log(data)
    //   this.upResName = data.speName001
    //   this.formAddGood.sellerCats = data.id
    //   this.$refs.selectUpResId.blur()
    // },

    // 商品分组删除
    deleteGrouping(taobaoItemGroupId) {
      deleteTaobaoItemGroup({ taobaoItemGroupId: taobaoItemGroupId }).then((res) => {
        this.getGrouping();
        this.$message.success("删除成功");
      });
    },
    // 商品分组选择
    selectGroupAdd(taobaoItemGroupId) {
      getTaobaoItemFromGroup({ taobaoItemGroupId }).then((res) => {
        let arr3 = this.rightData.concat(res.data);
        let obj = [];
        let result = [];
        result = arr3.reduce((prev, cur, index, arr) => {
          obj[cur.numIid] ? "" : (obj[cur.numIid] = true && prev.push(cur));
          return prev;
        }, []);
        this.rightData = result;
        this.groupingVisible = false;
      });
    },
    // 新增分组
    sumbitGroup() {
      let obj = {};
      if (this.formsaveGroup.radio == 1) {
        if (!this.formsaveGroup.name) {
          this.$message.warning("请输入分组名称");
          return;
        }
        obj = {
          name: this.formsaveGroup.name,
          itemIds: this.rightDataId.join(","),
        };
      } else {
        if (!this.formsaveGroup.selectName) {
          this.$message.warning("请选择分组名称");
          return;
        }
        obj = {
          taobaoItemGroupId: this.formsaveGroup.selectName,
          itemIds: this.rightDataId.join(","),
        };
      }
      this.saveGroupLoading = true;
      addTaobaoItemGroup(obj)
        .then((res) => {
          this.saveGroupLoading = false;
          this.saveGroupVisible = false;
          this.$message.success("保存成功");
        })
        .catch((err) => {
          this.saveGroupLoading = false;
        });
    },
    // 宝贝分组弹窗
    handleBabyGroup() {
      this.groupingVisible = true;
      this.getGrouping();
    },
    // 宝贝分组数据
    getGrouping(isList) {
      this.groupingTableLoading = true;
      let obj = {};
      if (isList) {
        obj = {
          pageNum: 1,
          pageSize: 1000000,
        };
        taobaoItemGroupList(obj).then((res) => {
          this.groupingSelect = res.data.dataList;
        });
      } else {
        obj = this.formGrouping;
        taobaoItemGroupList(obj).then((res) => {
          this.groupingTableLoading = false;
          this.groupingData = res.data.dataList;
          this.groupingTotal = res.data.pageInfo.total * 1;
        });
      }
    },
    // 宝贝分组分页
    handleCurrentGroupingChange(val) {
      this.formGrouping.pageNum = val;
      this.getGrouping();
    },
    handleSizeGroupingChange(val) {
      this.formGrouping.pageNum = 1;
      this.formGrouping.pageSize = val;
      this.getGrouping();
    },
    // 递归去除最后一级child
    recursionGoods(res) {
      res.forEach((e) => {
        if (e.child.length) {
          this.recursionGoods(e.child);
        } else {
          delete e.child;
        }
      });
    },
    // 添加下架商品
    addGoodSold() {
      if (!this.formAddGood.itemTitle) {
        this.$message.warning("请输入商品名称");
        return;
      }
      if (!this.formAddGood.numIid) {
        this.$message.warning("请输入商品ID");
        return;
      }
      this.addGoodLoading = true;
      addUnshelveItem(this.formAddGood)
        .then((res) => {
          this.addGoodLoading = false;
          this.$message.success(res.message);
          this.getTaobaoItemList();
          this.handleAddGoodClose();
        })
        .catch((err) => {
          this.addGoodLoading = false;
        });
    },
    handleAddGoodClose() {
      this.addGoodVisible = false;
    },
    handleSaveGroupClose() {
      this.saveGroupVisible = false;
    },
    handleGroupingClose() {
      this.groupingVisible = false;
    },
    // 保存为分组窗口
    handleSaveFZ() {
      if (this.rightPaginationInfo.totalCount == 0) {
        this.$message.warning("请先选择宝贝");
        return;
      }
      this.getGrouping(true);
      this.saveGroupVisible = true;
    },
    load() {
      // let index = this.loadIndex;
      // let data =  this.specifyData[index];
      // this.brandOptions.push(data);
      // this.loadIndex++;
      let data = [];
      // console.log(this.specifyform);
      getBrandList(this.specifyform)
        .then((res) => {
          // console.log("%c 品牌列表", "color: green", res.data);
          if (res.code === 200) {
            console.log(res);
            data = res.data.dataList;
            data.forEach((item) => {
              this.specifyData.push(item);
            });
            this.brandOptions = this.specifyData;
          }
        })
        .then(() => {
          this.specifyform.pageNum++;
        });
    },
    validNum(val) {
      console.log(val);
      this.numIid = val.replace(/[^0-9,]+/g, "");
    },
    changeNum(val) {
      let that = this,
        testArr = [];
      this.numIid.split(",").forEach((val) => {
        if (val != "" && /^[0-9]+$/.test(val)) {
          testArr.push(val);
        }
      });
      this.numIid = testArr.join(",");
    },
    // 跳到对应商品购买页
    toGoodDetail(val) {
      if (val.length > 0) {
        window.open(val, "_blank");
      }
    },
    /*
     * 商品类目全选按钮监听事件
     * */
    handleCheckAllChangeTaoBao(val) {
      if (val) {
        if (this.classifyIndex === 1) {
          this.$refs.taobaoTree.setCheckedNodes(this.taobaoCats);
        } else {
          this.$refs.sellerTree.setCheckedNodes(this.sellerCats);
        }
      } else {
        if (this.classifyIndex === 1) {
          this.$refs.taobaoTree.setCheckedNodes([]);
        } else {
          this.$refs.sellerTree.setCheckedNodes([]);
        }
      }
    },
    handleCheckAllChange(val) {
      // console.log("%c 品牌全选事件", "color: green", val);
      this.checkedBrands = val ? this.brandOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedBrandsChange(value) {
      // console.log("%c 品牌单选事件", "color: green", value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.brandOptions.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.brandOptions.length;
    },
    /* 品牌弹窗确认按钮 */
    brandConfirm() {
      const that = this;
      let checkedBrands = that.checkedBrands;
      let checkedBrandsArray = [];
      checkedBrands.forEach(function(value) {
        checkedBrandsArray.push(value.pid);
      });
      // console.log("%c 选中的品牌Id", "color: green", checkedBrandsArray);
      that.checkedBrandsString = checkedBrandsArray.join(",");
      that.brandVisible = false;
    },
    /*
     * 监听类目的变化
     * */
    classifyChange(value) {
      this.classifyIndex = value;
      this.checkedAll = false;
      this.classifyIdArray = [];
      this.classifyIdString = "";
    },
    /*
     * 树形控件相关
     * */
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
      // 判断全选状态，根据索引来
      if (this.classifyIndex === 1) {
        // console.log('淘宝');
        let arr = this.$refs.taobaoTree.getCheckedKeys();
        // console.log(arr)
        // console.log(this.taobaoCats)
      } else {
        // console.log('店铺');
        let arr = this.$refs.sellerTree.getCheckedKeys();
        // console.log(arr)
        // console.log(this.sellerCats)
      }
    },
    /*
     * 确认类目事件
     * */
    getCheckedKeys() {
      const that = this;
      let classifyIndex = that.classifyIndex;
      let classifyIdArray = [];
      if (classifyIndex == 1) {
        // console.log(that.$refs.taobaoTree.getCheckedKeys());
        classifyIdArray = that.$refs.taobaoTree.getCheckedKeys();
        that.classifyIdArray = classifyIdArray;
        that.classifyIdString = classifyIdArray.join(",");
      } else if (classifyIndex == 2) {
        // 获取所有选中的id
        // console.log(that.$refs.sellerTree.getCheckedKeys());
        classifyIdArray = that.$refs.sellerTree.getCheckedKeys();
        that.classifyIdArray = classifyIdArray;
        that.classifyIdString = classifyIdArray.join(",");
      }
      that.visible = false;
    },
    /*
     * 弹窗确认事件
     * */
    handleDialogConfirm() {
      // 去除限制
      // if (this.rightData.length > this.maxNum) {
      //   this.$message.warning("只能选择" + this.maxNum + "个商品");
      //   return;
      // }
      const that = this;
      let rightData = that.rightData;
      // let numIids = [];
      // console.log(that.modelName.type)
      if (rightData.length > 0) {
        rightData.forEach(function(value) {
          value.type = that.$store.state.modelName.type;
          value.Warenauswahl = that.Warenauswahl;
        });
        rightData[0].shopType = this.shopType;
      } else {
        this.$emit("myShopType", this.shopType);
      }
      let newRightData = this.deepCopy(rightData);
      if (!this.skuIsShow) {
        newRightData.forEach((item) => {
          delete item.skuId;
          delete item.skuIdlen;
        });
      }
      //   重新赋值
      newRightData = newRightData.map((item) => {
        return {
          ...item,
          wareId: item.numIid,
          skuId: item.numIid,
          title: item.itemTitle,
          logo: item.picUrl,
        };
      });
      console.log(newRightData);
      this.$emit("transferName", newRightData, 1);
      this.selectDialog = true;
    },
    /*
     * 弹窗关闭事件
     * */
    handleDialogClose() {
      const that = this;
      console.log(that.Warenauswahl);
      let rightData = that.rightData;
      rightData.forEach(function(value) {
        value.type = that.$store.state.modelName.type;
        value.Warenauswahl = that.Warenauswahl;
      });
      this.$emit("transferName", [], 0);
      this.selectDialog = true;
    },
    /*
     * 获取淘宝商品列表
     * */
    getTaobaoItemList() {
      /**
       * approveStatus (string, optional): 商品状态 不填查全部，在售 1，待售 2 ,//
        categoryType (string, optional): 商品类目类型 0店铺类目 1淘宝类目 ,//
        cid (string, optional): 商品类目ID 勾选父级 传入相应子集 英文逗号拼接 1,2,3 ,//
        endPrice (string, optional): 商品价格区间 ,//
        itemTitle (string, optional): 商品名称 ,//
        numIid (string, optional): 商品id ,itemTitle -//
        pageNum (integer, optional): 当前页 ,//
        pageSize (integer, optional): 每页大小 ,//
        pid (string, optional): 商品品牌ID 英文逗号拼接 1,2,3 ,//
        startPrice (string, optional): 商品价格区间//
       */
      const self = this;
      let checkedBrandsString = self.checkedBrandsString, //指定品牌ID数组
        classifyIndex = self.classifyIndex, //商品类目类型
        classifyIdString = self.classifyIdString, //宝贝类目id数组
        itemTitle = self.itemTitle, //商品名称(请输入商品名称、商品编码、商品id、关键词)
        goodValue = self.goodValue, //商品状态
        startPrice = self.startPrice, //开始价格
        endPrice = self.endPrice; //结束价格
      // 判断商品类目 0店铺类目 1淘宝类目
      if (classifyIndex === 2) {
        // 店铺
        classifyIndex = 0;
      }
      // 判断商品状态 不填''查全部，在售 1，待售 2
      if (self.goodValue === 0) {
        goodValue = "";
      }
      var formData = {
        approveStatus: goodValue,
        categoryType: classifyIndex,
        cid: classifyIdString,
        endPrice: endPrice,
        itemTitle: itemTitle, //商品名称
        numIid: self.numIid, //商品id
        pageNum: self.leftPaginationInfo.current,
        pageSize: self.leftPaginationInfo.pageSize,
        pid: checkedBrandsString,
        startPrice: startPrice,
      };
      // console.log(formData);
      getTaobaoItemList(formData).then((res) => {
        if (res.code === 200) {
          //res={"code":200,"message":"查询数据成功","data":{"dataList":[{"taobaoItemId":"5217","numIid":"567584257216","itemTitle":"测试请不要购买羊绒裤薄款打底裤高腰中厚羊毛裤保暖","picUrl":"https://img.alicdn.com/bao/uploaded/i2/2178913095/TB1FHUDdndYBeNkSmLyXXXfnVXa_!!0-item_pic.jpg","price":"3.00","titleShort":"4","itemLink":"https://item.taobao.com/item.htm?id=567584257216","defaultBuyerRebuyAvgDate":""},{"taobaoItemId":"5220","numIid":"568563132877","itemTitle":"测试商品不发货","picUrl":"https://img.alicdn.com/bao/uploaded/i3/2178913095/TB2Jdb3hpXXXXbJXXXXXXXXXXXX_!!2178913095.jpg","price":"0.01","itemLink":"https://item.taobao.com/item.htm?id=568563132877","defaultBuyerRebuyAvgDate":""},{"taobaoItemId":"5219","numIid":"571600111179","itemTitle":"创意小礼品批發微商开业精美礼物地推活动回礼伴手礼定制logo实用","picUrl":"https://img.alicdn.com/bao/uploaded/i2/2178913095/TB1bLMWw9tYBeNjSspkXXbU8VXa_!!0-item_pic.jpg","price":"100.00","itemLink":"https://item.taobao.com/item.htm?id=571600111179","defaultBuyerRebuyAvgDate":""},{"taobaoItemId":"5218","numIid":"581496921524","itemTitle":"宝贝还行","picUrl":"https://img.alicdn.com/bao/uploaded/i4/2178913095/TB2m1ldhpXXXXcfXpXXXXXXXXXX_!!2178913095.jpg","price":"100.00","itemLink":"https://item.taobao.com/item.htm?id=581496921524","defaultBuyerRebuyAvgDate":""}],"pageInfo":{"pageNum":1,"pageSize":10,"size":4,"startRow":1,"endRow":4,"total":4,"pages":1,"prePage":0,"nextPage":0,"isFirstPage":true,"isLastPage":true,"hasPreviousPage":false,"hasNextPage":false,"navigatePages":8,"navigatepageNums":[1],"navigateFirstPage":1,"navigateLastPage":1,"firstPage":1,"lastPage":1}}};
          let dataList = res.data.dataList;
          //(function makearr(arr){console.log(arr);if(arr && arr.length<10000){makearr([...JSON.parse(JSON.stringify(arr)),...JSON.parse(JSON.stringify(arr))])}else{dataList=arr;return;}})(dataList);
          // for (let i = 0; i < dataList.length; i++) {
          //  dataList[i].numIid = i;
          // }
          //res.data.pageInfo.total=dataList.length;
          //dataList=dataList.splice((formData.pageNum-1)*formData.pageSize,formData.pageSize);
          //给商品列表添加一个state属性判断是否可以被选中
          for (let i = 0; i < dataList.length; i++) {
            dataList[i].state = false;
            dataList[i].skuIdlen = 0;
          }
          self.newData = dataList;
          self.leftData = dataList;
          //根据右边判断
          if (self.rightData.length === 0) {
            // 首次加载
            // console.log("首次加载");
            // self.leftData = dataList
          } else {
            for(let i=0;i<self.rightData.length;i++){
              if(self.rightData[i].skuId){
                self.rightData[i] = Object.assign(self.rightData[i],res.data.dataList.filter(item => item.numIid == self.rightData[i].skuId)[0])
              }
            }
            // console.log("已有数据");
            // console.log(self.leftData);
            //获取的数据与原数据对比(numIid),无则追加，有则跳过
            let nowList = self.newData; //当前新获取的数据
            let newList = []; //不存在旧数据的临时数据
            for (const newItem of nowList) {
              let i = 0;
              for (const oldItem of self.rightData) {
                i++;
                if (newItem.numIid != oldItem.numIid) {
                  if (i === self.rightData.length) {
                    // 内层循环完新添加进新数组
                    newList.push(newItem);
                  }
                  continue;
                } else {
                  break;
                }
              }
            }
            // 追加新加的元素 (右边和最新数据对比过滤)
            // console.log(newList);
            if (newList.length === 0) {
              for (const item of self.leftData) {
                item.state = true;
              }
            } else {
              for (const item1 of self.leftData) {
                let i = 0;
                for (const item of newList) {
                  i++;
                  if (item1.numIid != item.numIid) {
                    if (i === newList.length) {
                      // 内层循环完新添加进新数组
                      item1.state = true;
                    }
                    continue;
                  } else {
                    break;
                  }
                }
              }
            }
          }
          self.leftPaginationInfo.total = res.data.pageInfo.total * 1;
        }
      });
    },
    // getTaobaoItemList() {
    //   /**
    //    * approveStatus (string, optional): 商品状态 不填查全部，在售 1，待售 2 ,//
    //     categoryType (string, optional): 商品类目类型 0店铺类目 1淘宝类目 ,//
    //     cid (string, optional): 商品类目ID 勾选父级 传入相应子集 英文逗号拼接 1,2,3 ,//
    //     endPrice (string, optional): 商品价格区间 ,//
    //     itemTitle (string, optional): 商品名称 ,//
    //     numIid (string, optional): 商品id ,itemTitle -//
    //     pageNum (integer, optional): 当前页 ,//
    //     pageSize (integer, optional): 每页大小 ,//
    //     pid (string, optional): 商品品牌ID 英文逗号拼接 1,2,3 ,//
    //     startPrice (string, optional): 商品价格区间//
    //    */
    //   const self = this;
    //   let checkedBrandsString = self.checkedBrandsString, //指定品牌ID数组
    //     classifyIndex = self.classifyIndex, //商品类目类型
    //     classifyIdString = self.classifyIdString, //宝贝类目id数组
    //     itemTitle = self.itemTitle, //商品名称(请输入商品名称、商品编码、商品id、关键词)
    //     goodValue = self.goodValue, //商品状态
    //     startPrice = self.startPrice, //开始价格
    //     endPrice = self.endPrice; //结束价格
    //     // 判断商品类目 0店铺类目 1淘宝类目
    //   if (classifyIndex === 2) {
    //     // 店铺
    //     classifyIndex = 0
    //   }
    //   // 判断商品状态 不填''查全部，在售 1，待售 2
    //   if (self.goodValue === 0) {
    //     goodValue = ''
    //   }
    //   var formData = {
    //     approveStatus: goodValue,
    //     categoryType: classifyIndex,
    //     cid: classifyIdString,
    //     endPrice: endPrice,
    //     itemTitle: itemTitle,//商品名称
    //     numIid: self.numIid,//商品id
    //     pageNum: self.leftPaginationInfo.current,
    //     pageSize: self.leftPaginationInfo.pageSize,
    //     pid: checkedBrandsString,
    //     startPrice: startPrice
    //   }
    // console.log(formData)
    //   getTaobaoItemList(formData).then(res => {
    //     if (res.code === 200) {
    //       let dataList = res.data.dataList;
    //       //给商品列表添加一个state属性判断是否可以被选中
    //       for (let i = 0; i < dataList.length; i++) {
    //         dataList[i].state = false;
    //       }
    //       self.newData = dataList
    //       if(self.leftData.length === 0) {
    //         // 首次加载
    //         console.log('首次加载')
    //         for (const item of dataList) {
    //           self.leftData.push(item)
    //         }
    //       } else {
    //         console.log('已有数据')
    //         console.log(self.leftData)
    //         //获取的数据与原数据对比(numIid),无则追加，有则跳过
    //         let nowList = self.newData;//当前新获取的数据
    //         let newList =  [];//不存在旧数据的临时数据
    //         for (const newItem of nowList) {
    //           let i = 0
    //           for (const oldItem of self.leftData) {
    //             i++
    //             if(newItem.numIid != oldItem.numIid) {
    //               if (i === self.leftData.length) {
    //                 // 内层循环完新添加进新数组
    //                 newList.push(newItem)
    //               }
    //               continue
    //             }
    //             else {
    //               break
    //             }
    //           }
    //         }
    //         // 追加新加的元素
    //         console.log(newList)
    //         for (const item of newList) {
    //           self.leftData.push(item)
    //         }
    //       }
    //       self.leftPaginationInfo.total = res.data.pageInfo.total;
    //     }
    //   })
    // },
    /*
     * 左侧商品分页事件
     * */
    leftCurrentChange(event) {
      this.leftPaginationInfo.current = event.current;
      this.leftPaginationInfo.pageSize = event.pageSize;
      this.getTaobaoItemList();
    },
    /*
     * 左侧表格单选按钮
     * */
    async handleSelect(row, index) {
      console.log('row>>',row,index)
      const that = this;
      if (that.rightData.length >= that.maxNum) {
        this.$message.warning("选择商品不能超过" + that.maxNum + "个");
        return;
      }
      // 获取商品sku信息
      let skuArr = await this.getTaobaoItemSku(row.numIid);
      // console.log(skuArr);
      let leftData = that.leftData;
      let rightData = that.rightData;
      if (row.state === false) {
        this.$set(row, "skuId", skuArr);
        rightData.push(row);
        leftData[index].state = true;
      }

      that.rightData = rightData;
      that.leftData = leftData;
      that.rightPaginationInfo.totalCount = rightData.length;
    },
    /*
     * 左侧表格全选按钮
     * */
    // handleAllSelect() {
    //   const that = this;
    //   let leftData = that.leftData;
    //   let rightData = that.rightData;
    //   if(that.rightData.length == that.maxNum) {
    //     this.$message.warning('只能选择'+that.maxNum+'个商品')
    //   }
    //   for (let i = 0; i < leftData.length; i++) {
    //     if (leftData[i].state === false && that.rightData.length < that.maxNum) {
    //       let skuArr = this.getTaobaoItemSku(leftData[i].numIid);
    //       this.$set(leftData[i], "skuId", skuArr);
    //       rightData.push(leftData[i]);
    //       leftData[i].state = true;
    //     }
    //   }
    //   that.leftData = leftData;
    //   that.rightData = rightData;

    //   that.rightPaginationInfo.totalCount = rightData.length;
    // },
    handleAllSelect() {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;
      var Num = [];
      let skuArr = [];
      if ((that.rightData.length+leftData.length) > that.maxNum) {
        this.$message.warning("选择商品不能超过" + that.maxNum + "个");
        return;
      }
      for (let i = 0; i < leftData.length; i++) {
        if (leftData[i].state === false) {
          Num.push(leftData[i].numIid);
          // let skuArr = this.getTaobaoItemSku(leftData[i].numIid);
          this.$set(leftData[i], "skuId", this.skuArrTd);
          rightData.push(leftData[i]);
          leftData[i].state = true;
        }
      }
      this.getTaobaoItemSku(Num.join(","));
      that.leftData = leftData;
      that.rightData = rightData;
      that.rightPaginationInfo.totalCount = rightData.length;
    },
    /*
     * 左侧表格状态颜色
     * */
    tableRowClassName({ row }) {
      if (row.state === true) {
        return "success-row";
      }
      return "";
    },
    /*
     * 右侧表格删除按钮
     * */
    handleDelete(row, index) {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;
      // rightData.splice(index, 1);
      rightData.forEach((e, i) => {
        if (e.numIid == row.numIid) {
          rightData.splice(i, 1);
        }
      });
      for (let i = 0; i < leftData.length; i++) {
        if (leftData[i].numIid == row.numIid) {
          that.leftData[i].state = false;
        }
      }
      that.rightPaginationInfo.totalCount = rightData.length;
      that.rightData = rightData;
    },
    /*
     * 右侧表格清空按钮
     * */
    handleClear() {
      const that = this;
      let leftData = that.leftData;
      let rightData = that.rightData;

      for (let i = 0; i < rightData.length; i++) {
        for (let j = 0; j < leftData.length; j++) {
          if (rightData[i].numIid == leftData[j].numIid) {
            leftData[j].state = false;
          }
        }
      }
      that.leftData = leftData;

      rightData.splice(0, rightData.length);
      that.rightPaginationInfo.totalCount = 0;
    },

    /*
     * 右侧分页事件
     * */
    rightCurrentChange(val) {
      this.rightPaginationInfo.pageSize = val.pageSize;
      this.rightPaginationInfo.tableCurrentPage = val.current;
      this.rightDataNow = this.rightData.slice(
        (this.rightPaginationInfo.tableCurrentPage - 1) * this.rightPaginationInfo.pageSize,
        this.rightPaginationInfo.tableCurrentPage * this.rightPaginationInfo.pageSize
      );
    },
    /*
     * 查询按钮
     * */
    searchList() {
      // 执行查询接口
      this.leftPaginationInfo.current = 1;
      this.leftPaginationInfo.pageSize = 10;
      this.getTaobaoItemList();
    },
    /**
     * 商品sku属性选中
     */
    selectSkuInfo(info, row) {
      console.log(info);
      info.skuIsActive = !info.skuIsActive;
      if (info.skuIsActive) {
        row.skuIdlen++;
      } else {
        row.skuIdlen--;
      }
    },
    /**
     * 获取淘宝sku属性
     */
    getTaobaoItemSku(id) {
      let skuArr = [];
      getTaobaoItemSkuList({ numIid: id }).then((res) => {
        res.data.forEach((item) => {
          let str = "",
            arr = null;
          arr = item.propertiesName.split(";");

          arr.forEach((d, idx) => {
            let sku = d.split(":");
            if (idx == arr.length - 1) {
              str += sku[sku.length - 1];
            } else {
              str += sku[sku.length - 1] + "; ";
            }
          });
          skuArr.push({
            propertiesName: str,
            skuId: item.skuId,
            skuIsActive: false,
          });
        });
      });
      this.skuArrTd = skuArr;
      return skuArr;
    },
    /**
     * 深拷贝函数
     */
    deepCopy(obj) {
      var result = Array.isArray(obj) ? [] : {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object") {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .short-popup {
}
/deep/ .el-pagination {
  // overflow-x: scroll!important;
  // text-align: left !important;
}

.select-goods {
  z-index: 5000 !important;
  .searchBtn {
    width: 72px;
    height: 32px;
    font-size: 14px;
    padding: 0px;
  }
}

.evaluate-dialog-wrapper {
  .screen-box {
    .line {
      font-size: 14px;
      color: #666666;
      margin-bottom: 10px;
      .item {
        display: inline-block;
        vertical-align: middle;
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
        .brandButton {
          width: 300px;
        }
        .classify-select {
          display: inline-block;
          vertical-align: middle;
          width: 145px;
          margin-right: 13px;
        }
        .goods-button {
          display: inline-block;
          vertical-align: middle;
          width: 141px;
        }
        .long-input {
          width: 270px;
        }
        .goods-select {
          width: 200px;
        }
        .short-input {
          width: 85px;
          display: inline-block;
          vertical-align: middle;
        }
        .text {
          display: inline-block;
          margin: 0 10px;
        }
      }
    }
  }
  .table-box {
    overflow: hidden;
    margin-top: 12px;
    .table-left {
      float: left;
      overflow: hidden;
      .goods-img {
        width: 56px;
        float: left;
        margin-right: 7px;
      }
      .goods-content {
        float: left;
        // width: 325px;
        width: 336px;
        .goods-title {
          display: block;
          text-align: left;
          margin-bottom: 6px;
        }
        .goods-title:hover {
          color: #2062e7;
          cursor: pointer;
          text-decoration: underline;
        }
        .goods-detail {
          display: block;
          overflow: hidden;
          .goods-id {
            display: block;
            float: left;
            color: #999999;
          }
          .goods-price {
            display: block;
            float: right;
            .price {
              font-size: 16px;
            }
          }
        }
      }
      .add-button {
        font-size: 24px;
        cursor: pointer;
      }
      .addDisabled {
        cursor: not-allowed;
      }
    }
    .table-right {
      float: right;
      overflow: hidden;
      .is-select {
        color: #ff7600;
      }
      .goods-img {
        width: 56px;
        float: left;
        margin-right: 7px;
        margin-top: 8px;
      }
      .goods-content {
        float: left;
        width: 325px;
        width: 336px;
        .goods-title {
          display: block;
          text-align: left;
          margin-bottom: 6px;
        }
        .goods-title:hover {
          color: #2062e7;
          cursor: pointer;
          text-decoration: underline;
        }
        .goods-detail {
          display: block;
          overflow: hidden;
          .goods-id {
            display: block;
            float: left;
            color: #999999;
          }
          .goods-price {
            display: block;
            float: right;
            .price {
              font-size: 16px;
            }
          }
        }
        .selectSku {
          text-align: left;
          color: #2062e7;
          cursor: pointer;
        }
      }
      .delete-button {
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
}
.specsList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  span {
    margin-right: 6px;
    margin-bottom: 6px;
    padding: 4px 8px;
    border: 1px solid #f3f3f3;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #fff;
    background-color: #5882fb;
  }
}
/* 滚动条样式修改 */
.popper-wrapper,
.el-checkbox-group {
  /* background-color: #666; */
  max-height: 250px !important;
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-checkbox-group::-webkit-scrollbar,
.popper-wrapper::-webkit-scrollbar {
  width: 0px;
  background-color: #fff;
  border-radius: 10px;
  padding: 5px 0;
}
.el-checkbox-group:hover::-webkit-scrollbar,
.popper-wrapper:hover::-webkit-scrollbar {
  width: 6px;
}
.el-checkbox-group::-webkit-scrollbar,
.popper-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #d6d8dd;
  overflow: hidden;
}
.addGoodItem {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  .item-left {
    width: 100px;
    text-align: right;
  }
  .item-right {
    width: 300px;
  }
}
</style>

<style lang="scss">
.my_select_goods {
  .el-dialog {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16) !important;
  }
  .el-dialog__body {
    padding-bottom: 20px;
  }
  .el-dialog__footer {
    padding: 25px 0px 30px;
    .dialog-footer {
      margin: 0px;
      padding: 0px;
      button {
        width: 96px;
        font-size: 14px;
        padding: 0px;
        line-height: 30px;
      }
    }
  }
}

.el-popper {
  padding: 10px !important;
  max-height: 600px;
  // overflow-y: auto;
}

.el-table .success-row {
  background: #f5f7fa;
  cursor: not-allowed;
  opacity: 0.4;
}
.addDisabled {
  cursor: not-allowed;
}
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
.el-select-dropdown.el-popper {
  z-index: 5100 !important;
}
.el-popover.el-popper {
  z-index: 6001 !important;
}
.el-popper.el-cascader__dropdown {
  z-index: 6001 !important;
}

/deep/ .select-goods.el-table__body-wrapper {
  // overflow: visible !important;
  overflow: auto !important;
}
</style>
